import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import { Row } from 'react-bootstrap';
import SelfFaultEvaluationCommentActions from './SelfFaultEvaluationCommentActions';
import SelfFaultEvaluationCommentList from './SelfFaultEvaluationCommentList';
import ErrorView from 'sharedComponents/ErrorBoundary/ErrorView';
import { apiCallStatus } from 'helpers/constants';
import { useReportIssue } from 'sharedHooks/useReportIssue';
import './style.scss';


const SelfEvaluateComponent = ({ actions, model, selectedAsset }) => {
	const { showReportIssue } = useReportIssue();

	useEffect(() => {
		actions.getComments(model?.selectedEvent);
	}, []);

	if (model?.errorData?.loadingStatus === apiCallStatus.ERROR) {
		return <ErrorView
			errorCode={model.errorData.errorCode}
			onRetry={() => actions.getComments(model.selectedEvent)}
			onReportIssue={showReportIssue}
		/>;
	}

	return (
		<div className='self-evaluate-comments-section'>
			<Row>
				<SelfFaultEvaluationCommentActions
					model={model}
					actions={actions}
				/>

				<SelfFaultEvaluationCommentList
					model={model}
					actions={actions}
					selectedAsset={selectedAsset}
				/>
			</Row>
		</div>
	);
};

SelfEvaluateComponent.propTypes = {
	actions: PropTypes.shape({
		getComments: PropTypes.func, // Function to fetch comments for the selected event
	}), // Actions object containing functions
	model: PropTypes.shape({
		errorData: PropTypes.shape({
			loadingStatus: PropTypes.string,
			errorCode: PropTypes.number,
		}),
		selectedEvent: PropTypes.shape({
			id: PropTypes.string, // Event ID
			rawEvent: PropTypes.shape({
				isInitialCause: PropTypes.bool, // Whether the event is the initial cause
			}), // Raw event details
		}), // Selected event details
		comments: PropTypes.arrayOf(
			PropTypes.shape({
				id: PropTypes.string, // Comment ID
				text: PropTypes.string, // Comment text
				user: PropTypes.string, // User who posted the comment
				timestamp: PropTypes.string, // Timestamp of the comment
			})
		), // Array of comments
		postCommentStatus: PropTypes.string, // Status of the post comment API call
		getCommentStatus: PropTypes.string, // Status of the get comments API call
	}), // Model containing state data
	selectedAsset: PropTypes.shape({
		id: PropTypes.string, // Asset ID
		serialNumber: PropTypes.string, // Asset serial number
		name: PropTypes.string, // Asset name
	}), // Selected asset details
};

export default SelfEvaluateComponent;
